import { Module } from 'vuex'

import { GetCourseStatisticsUseCase } from '@/application/problem/getCourseStatisticsUseCase'
import { Course } from '@/domain/entities/problem/course'
import { ProblemRepository } from '@/domain/repositories/problem/ProblemRepository'
import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

interface CourseStatisticsState {
  courseStatisticsList: { [programLanguage: string]: Course }
  isLoading: boolean
  error: string | null
}

export const courseStatisticsModule = (problemRepository: ProblemRepository): Module<CourseStatisticsState, any> => {
  const getCourseStatisticsUseCase = new GetCourseStatisticsUseCase(problemRepository)

  return {
    namespaced: true,
    state: {
      courseStatisticsList: {},
      isLoading: false,
      error: null
    },
    mutations: {
      setCourseStatistics(
        state,
        { course, programLanguage }: { course: Course; programLanguage: ProgramLanguageType }
      ) {
        state.courseStatisticsList = {
          ...state.courseStatisticsList,
          [programLanguage]: course
        }
      },
      clearCourseStatisticsList(state) {
        state.courseStatisticsList = {}
      },
      setIsLoading(state, isLoading: boolean) {
        state.isLoading = isLoading
      },
      setError(state, error: string | null) {
        state.error = error
      }
    },
    actions: {
      async getCourseStatisticsListByLanguage(
        { state, commit },
        {
          courseName,
          userId,
          programLanguage
        }: { courseName: string; userId: string; programLanguage: ProgramLanguageType }
      ): Promise<Course | undefined> {
        commit('setIsLoading', true)
        commit('setError', null)
        try {
          const newLanguage = programLanguage.replace(' (Beta)', '').replace('#', '%23')
          if (state.courseStatisticsList[newLanguage] != undefined) return state.courseStatisticsList[newLanguage]
          const res = await getCourseStatisticsUseCase.getCourseStatisticsByLanguage(
            courseName,
            userId,
            programLanguage
          )
          commit('setCourseStatistics', { course: res, programLanguage: newLanguage })
          return res
        } catch (e) {
          commit('setError', e)
        } finally {
          commit('setIsLoading', false)
        }
      }
    },
    getters: {
      courseStatisticsList: state => state.courseStatisticsList,
      isLoading: state => state.isLoading,
      error: state => state.error
    }
  }
}
